export default __webpack_public_path__ + "static/media/core5.4088fb35.png";